import { PengelolaanKinerjaTimeline } from 'app/KinerjaShared/components/PengelolaanKinerjaTimeline'
import CardPanduan from 'app/KinerjaShared/components/CardPanduan'
import KinerjaSidebar from 'app/KinerjaShared/components/KinerjaSidebar'
import { PemantauanPelaksanaanPegawaiCard } from 'app/KinerjaShared/components/PemantauanPelaksanaanPegawaiCard'
import { PENGELOLAAN_KINERJA_KEPALA_SKB_TIM_KINERJA_PATH } from 'app/KinerjaShared/constants/path'

export function Homepage() {
  return (
    <div className="flex w-full min-h-screen">
      <div className="flex-shrink-0 min-h-full">
        <div className="w-64">{/* Sentinel element for sidebar spacing */}</div>
        <KinerjaSidebar activeMenu="penilik-penilai" sticky />
      </div>
      <div className="w-full gap-4 p-6 space-y-6">
        <PemantauanPelaksanaanPegawaiCard
          targetPath={`${PENGELOLAAN_KINERJA_KEPALA_SKB_TIM_KINERJA_PATH}/pelaksanaan`}
          pegawaiLabel="Kepala SKB"
        />

        <PengelolaanKinerjaTimeline
          timeline={[
            {
              title: 'Januari',
              steps: ['Perencanaan Kinerja'],
            },
            {
              title: 'Februari - November',
              steps: [
                'Persiapan Praktik Kinerja',
                'Pelaksanaan Observasi Praktik Kinerja',
                'Pelaksanaan Tindak Lanjut Praktik Kinerja',
              ],
            },
            {
              title: 'Desember',
              steps: ['Penetapan Predikat Kinerja'],
            },
          ]}
        />

        <CardPanduan />
      </div>
    </div>
  )
}
